import React, { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

export const Header = ({ onBookClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = [
    { id: "mounjaro", label: "Mounjaro" },
    { id: "how", label: "How it works" },
    { id: "timeline", label: "Timeline" },
    { id: "doctor", label: "Doctor" },
    { id: "faq", label: "FAQ" },
  ];

  return (
    <header
      data-testid="main-header"
      className={`fixed top-3 inset-x-3 md:top-5 md:inset-x-6 z-40 rounded-full transition-all ${
        scrolled ? "glass-pill shadow-[0_6px_30px_-14px_rgba(15,95,74,0.25)]" : "bg-white/60 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-6 h-14 md:h-16 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5">
          <img
            src="https://www.asiandiabeticcenter.in/wp-content/uploads/2026/03/asian-diabetic-logo.jpg"
            alt="Asian Diabetes Thyroid Hormone Superspeciality Centre"
            className="h-9 w-9 rounded-full object-cover border border-[#EAE7E1]"
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-display text-[14px] text-[#242220] font-semibold">Dr. Shalini Patlolla</span>
            <span className="text-[10px] tracking-[0.14em] uppercase text-[#6B6660]">Endocrinology · Diabetes · Weight Loss</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7 text-sm text-[#242220]/80">
          {nav.map((n) => (
            <a
              key={n.id}
              data-testid={`nav-${n.id}`}
              href={`#${n.id}`}
              className="hover:text-[#779D7C] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            data-testid="header-whatsapp"
            href="https://wa.me/919133552279"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent("whatsapp_clicked", { location: "header" })}
            className="hidden sm:inline-flex items-center gap-2 text-sm text-[#779D7C] hover:bg-[#E8F0E9] transition-all px-3 py-2 rounded-full"
          >
            <MessageCircle className="h-4 w-4" strokeWidth={1.7} />
            <span className="hidden md:inline">91335 52279</span>
          </a>
          <button
            data-testid="header-book-btn"
            onClick={() => { trackEvent("quiz_started", { location: "header" }); onBookClick(); }}
            className="inline-flex items-center gap-2 rounded-full bg-[#EB8771] hover:bg-[#E2725C] text-white text-sm px-5 py-2.5 font-medium shadow-[0_8px_20px_-8px_rgba(255,122,89,0.55)] transition-all hover:scale-[1.03]"
          >
            Get Started
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="lg:hidden grid place-items-center h-10 w-10 rounded-full text-[#242220] hover:bg-[#E8F0E9]"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden px-6 pb-5 pt-1 flex flex-col gap-3 text-sm text-[#242220]">
          {nav.map((n) => (
            <a key={n.id} onClick={() => setOpen(false)} href={`#${n.id}`} className="py-1">
              {n.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
